import { render, staticRenderFns } from "./VCarousel.vue?vue&type=template&id=9547cb46&scoped=true&"
import script from "./VCarousel.vue?vue&type=script&lang=js&"
export * from "./VCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VCarousel.vue?vue&type=style&index=0&id=9547cb46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9547cb46",
  null
  
)

component.options.__file = "VCarousel.vue"
export default component.exports